import firebase from '../firebase';

const storage = firebase.storage();

const storageRef = storage.ref();
export async function uploadToCloudStorage(files, userId) {
  const fileRef = storageRef.child(`dek64/useruploadimage/${userId}/${files[0].name}`);

  const snapshot = await fileRef.put(files[0]);

  const downloadURL = await snapshot.ref.getDownloadURL();
  return downloadURL;
}
